export class Directory {
    id: string;
    name: string;
    parentId: string | null;
}
